import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

interface IProps {
  teamId: string;
  enabled?: boolean;
}

const useByTeam = ({ teamId, enabled = true }: IProps) => {
  const query = useQuery({
    queryKey: ['collections', 'team', teamId],
    queryFn: async () => {
      const response = await Api.byTeam(teamId);
      return response.data.data;
    },
    enabled: enabled && Boolean(teamId),
  });

  return {
    collections: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useByTeam;
